import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ClientQuestionnaireModel } from '../../../../../../../common/dist/angular/models/client-questionnaire.model';
import { TransformerClassType } from '../../core/interceptors/transformer.http-interceptor';


@Injectable()
export class ClientQuestionnairesClientPortalApiController {
  constructor(private readonly httpClient: HttpClient, @Inject('environment.api.url') private readonly apiUrl: string) {
  }

  public async list(): Promise<ClientQuestionnaireModel[]> {
    return this.httpClient.get<{
      '_items': ClientQuestionnaireModel[],
      '_paginationResult': { 'total': number }
    }>(`${this.apiUrl}/api/client-portal/client-questionnaires`, {
      context: new HttpContext().set(TransformerClassType, ClientQuestionnaireModel),
    }).pipe(
      map(result => result._items),
    ).toPromise();
  }

  // private static map(questionnaire: ClientQuestionnaireModel) {
  //     return {
  //         ...questionnaire,
  //         updatedAt: new Date(questionnaire.updatedAt),
  //         createdAt: new Date(questionnaire.createdAt),
  //     }
  // }

}
